import React from 'react';
import _ from 'lodash';
import cx from 'classnames';
import Item from './item';

export default class Group extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showChildren: false,
    };
  }

  /**
   * Returns the currently selected children
   * @returns {Array}
   */
  selectedChildren() {
    return _.select(this.props.group.children, {
      selected: true,
    });
  }

  /**
   * Does the group have any selected children?
   * @returns {boolean}
   */
  anyChildrenSelected = () => this.props.group.children.some(c => c.selected);

  /**
   * Are all the group's children selected?
   * @returns {boolean}
   */
  allChildrenSelected = () => this.props.group.children.every(c => c.selected);

  /**
   * Toggle the display of the children
   */
  toggleChildrenDisplay = () => {
    this.setState(prevState => ({ showChildren: !prevState.showChildren }));
  };

  /**
   * Toggle all chilrens' selected state.
   * @param event
   */
  toggleSelectedChildren = event => {
    event.preventDefault();
    event.stopPropagation();
    var newValue = !this.allChildrenSelected();
    this.props.toggleItems(this.props.group.children, newValue);
  };

  componentDidMount() {
    this.setState({ showChildren: this.anyChildrenSelected() });
  }

  children() {
    if (this.state.showChildren) {
      return this.props.group.children.map((item, index) => (
        <Item
          className="child"
          item={item}
          toggle={this.props.toggleItems}
          key={index}
        />
      ));
    }
  }

  render() {
    var classes = ['grouped-item', 'border-color', 'group-parent'];
    const active = this.anyChildrenSelected();

    if (this.state.showChildren) {
      classes.push('open');
    }

    if (active) {
      classes.push('active');
    }

    return (
      <div className={cx(classes)}>
        <div className="grouped-item-label">
          <div onClick={this.toggleChildrenDisplay}>
            <i
              className={cx(
                'fa',
                'show-children',
                this.state.showChildren ? 'fa-angle-down' : 'fa-angle-right',
              )}
            />
            <span>{this.props.group.name}</span>
          </div>
          <a
            className="toggle-children"
            tabIndex={0}
            onClick={this.toggleSelectedChildren}
          >
            {!this.allChildrenSelected() ? 'Select all' : 'Clear'}
          </a>
        </div>
        {this.children()}
      </div>
    );
  }
}
